export default __webpack_public_path__ + "locales/pt/InfoPanel.json?hash=b0dde236cddd4ea0b7b83dc22cbf35d4";